module.exports = __webpack_public_path__ + "static/media/menu6.328e3ab2.jpg";